

























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Dropdown extends Vue {
  @Prop() label!: string;

  @Prop() items!: any;

  @Prop() disabled?: boolean;

  @Prop() rules!: any;

  @Prop() value!: any;

  @Prop() outline?: boolean;

  @Prop() placeholder?: string;

  @Prop() displayText?: string;

  @Prop() clearable?: boolean;

  @Prop({ type: Boolean, default: false }) loading?: boolean;

  update() {
    this.selectedValue(this.value);
  }

  selectedValue(value: any) {
    if (value === undefined) {
      value = null;
    }
    this.$emit('input', value);
  }

  clear() {
    this.$emit('clear');
  }
}
